import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const InterestsSection = ({ formData, errors, onChange }) => {
  const interestCategories = [
    {
      category: 'Lifestyle',
      icon: 'Coffee',
      interests: ['Travel', 'Food & Dining', 'Fitness', 'Yoga', 'Meditation', 'Shopping', 'Fashion', 'Photography']
    },
    {
      category: 'Entertainment',
      icon: 'Film',
      interests: ['Movies', 'Music', 'Dancing', 'Theatre', 'Concerts', 'Netflix', 'Gaming', 'Reading']
    },
    {
      category: 'Outdoor',
      icon: 'Mountain',
      interests: ['Hiking', 'Beach', 'Sports', 'Adventure', 'Nature', 'Camping', 'Cycling', 'Running']
    },
    {
      category: 'Social',
      icon: 'Users',
      interests: ['Parties', 'Nightlife', 'Wine Tasting', 'Cooking', 'Art', 'Museums', 'Volunteering', 'Networking']
    },
    {
      category: 'Intellectual',
      icon: 'BookOpen',
      interests: ['Philosophy', 'Politics', 'Science', 'Technology', 'Writing', 'Poetry', 'Learning', 'Debate']
    }
  ];

  const [selectedInterests, setSelectedInterests] = useState(formData?.interests || []);

  const handleInterestToggle = (interest) => {
    let updated;
    if (selectedInterests?.includes(interest)) {
      updated = selectedInterests?.filter(i => i !== interest);
    } else {
      if (selectedInterests?.length >= 10) {
        return;
      }
      updated = [...selectedInterests, interest];
    }
    setSelectedInterests(updated);
    onChange({ target: { name: 'interests', value: updated } });
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-warm">
      <div className="mb-4 md:mb-6">
        <h3 className="text-lg md:text-xl font-heading font-semibold mb-2">Interests</h3>
        <p className="text-sm text-muted-foreground">
          Select up to 10 interests that describe you ({selectedInterests?.length}/10 selected)
        </p>
      </div>
      <div className="space-y-6">
        {interestCategories?.map((category) => (
          <div key={category?.category}>
            <div className="flex items-center gap-2 mb-3">
              <Icon name={category?.icon} size={18} color="var(--color-primary)" />
              <h4 className="text-sm font-caption font-semibold">{category?.category}</h4>
            </div>
            <div className="flex flex-wrap gap-2">
              {category?.interests?.map((interest) => {
                const isSelected = selectedInterests?.includes(interest);
                return (
                  <button
                    key={interest}
                    type="button"
                    onClick={() => handleInterestToggle(interest)}
                    disabled={!isSelected && selectedInterests?.length >= 10}
                    className={`px-3 md:px-4 py-2 rounded-lg text-xs md:text-sm font-caption font-medium transition-smooth ${
                      isSelected
                        ? 'bg-primary text-primary-foreground'
                        : 'bg-muted text-foreground hover:bg-muted/80'
                    } ${!isSelected && selectedInterests?.length >= 10 ? 'opacity-50 cursor-not-allowed' : ''}`}
                  >
                    {interest}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      {errors?.interests && (
        <p className="mt-4 text-sm text-error">{errors?.interests}</p>
      )}
      {selectedInterests?.length >= 10 && (
        <div className="mt-4 p-3 bg-warning/10 rounded-lg flex items-start gap-2">
          <Icon name="AlertCircle" size={16} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
          <p className="text-xs text-foreground">
            You've reached the maximum of 10 interests. Remove some to add different ones.
          </p>
        </div>
      )}
    </div>
  );
};

export default InterestsSection;